/**
 * airan-ntn — xApp Base Class
 */

import { XAppConfig, XAppDecision, E2KpmReport, E2RcAction, XAppType } from '../types.js';
import { XAPP_DEFAULTS } from '../config.js';

export abstract class XAppBase {
  readonly config: XAppConfig;
  readonly name: string;
  protected kpmHistory: E2KpmReport[] = [];
  protected decisionLatencies: number[] = [];

  constructor(type: XAppType, enabled: boolean = true) {
    const defaults = XAPP_DEFAULTS[type];
    this.config = {
      type,
      enabled,
      priority: defaults.priority,
      decisionInterval: defaults.decisionInterval,
      requiredEventTriggers: defaults.eventTriggers,
      requiredReportStyle: defaults.reportStyle
    };
    this.name = type;
  }

  abstract processKpmReport(report: E2KpmReport): void;
  abstract decisionCycle(): XAppDecision;
  abstract getRequiredSubscription(): { eventTriggers: string[]; reportStyle: string };

  reset(): void {
    this.kpmHistory = [];
    this.decisionLatencies = [];
  }

  protected recordDecision(latencyMs: number): void {
    this.decisionLatencies.push(latencyMs);
    if (this.decisionLatencies.length > 1000) this.decisionLatencies.shift();
  }

  getAvgLatency(): number {
    if (this.decisionLatencies.length === 0) return 0;
    return this.decisionLatencies.reduce((a, b) => a + b, 0) / this.decisionLatencies.length;
  }
}